<template>
    <div>
        <div class="blank-list">
            <blank-cell v-for='(item,index) in dataList' :key='item.id' :content='item' :answerStatus='answerStatus' @sendInput='getInput' :itemIndex='index'></blank-cell>
        </div>
        <sub-btn @sub-answer="subAnswer" v-if="!answerStatus"></sub-btn>
    </div>
</template>
<script>
import BlankCell from 'components/PC/BlankCell'
import SubBtn from 'components/PC/SubBtn'
import psCommonMethods from './mixins/index.js'
export default {
  name: 'MorelineBlank',
  mixins: [psCommonMethods],
  data () {
    return {
      dataList: null,
      answerStatus: false,
      testTitleTxt: null
    }
  },
  created () {
    this.initData()
  },
  watch: {
    '$route' () {
      this.initData()
    }
  },
  methods: {
    initData () {
      const cIndex = this.$store.state.currentChapterIndex
      const pIndex = this.$store.state.currentPartIndex
      let data = this.data.part_list[pIndex].chapter_list[cIndex]
      this.testTitleTxt = data.chapter_content.quiz_title
      this.dataList = data.chapter_content.dry
      this.answerStatus = data.answerShow
    },
    subAnswer () {
      let result = this.checkInput()
      if (result) {
        this.answerStatus = true
        this.setChaperAnswer(this.dataList)// 提交用户答案
        // this.setLessonLocation(this.$store.state.currentPartIndex,this.$store.state.currentChapterIndex);
      } else {
        this.subAnswerAllow(true) // 显示全局提示
      }
    },
    checkInput () {
      let ansArr = []
      let result = null
      this.dataList.forEach((item, index) => {
        if (item.answer !== null && item.answer !== undefined) {
          ansArr.push(1)
        } else {
          ansArr.push(0)
        }
      })
      if (ansArr.indexOf(0) > -1) {
        result = false
      } else {
        result = true
      }
      return result
    },
    getInput (value) {
      if (value.itemInput === '' || value.itemInput === undefined) {
        this.dataList[value.itemIndex].answer = null
      } else {
        this.dataList[value.itemIndex].answer = value.itemInput
      }
    }
  },
  components: {
    BlankCell,
    SubBtn
  }
}
</script>
<style lang="less" scoped>
.blank-list{
    padding:0 54px 44px;
}
</style>
